import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, CircularProgress, Select, Dialog, DialogTitle, DialogContent, DialogActions, Chip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DataTable from "../components/DataTable";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import SnackbarAlert from "../components/SnackbarAlert";
export default function UserEnquiry() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [status, setStatus] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const getStatusColor = (status) => {
        switch (status) {
            case "NEW":
                return { bg: "#2196f3", color: "#fff" };
            case "IN_PROGRESS":
                return { bg: "#ff9800", color: "#fff" };
            case "COMPLETED":
                return { bg: "#4caf50", color: "#fff" };
            case "CANCELLED":
                return { bg: "#f44336", color: "#fff" };
            default:
                return { bg: "#9e9e9e", color: "#fff" };
        }
    };
    useEffect(() => {
        fetchPlanData();
    }, []);
    const fetchPlanData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "enquiries";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filteredOrders = dataSource?.filter((d) =>
        d?.customer_mobile?.toLowerCase().includes(search?.toLowerCase())
    );
    const formatDate = (date) => {
        return new Date(date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    };
    const columns = ["S.No", "Enquiry Type", "Date", "Customer Name", "Mobile No", "Plan Name / Products Name", "Status", "Action"];
    const rows = filteredOrders?.map((o, i) => {
        const statusStyle = getStatusColor(o?.enquiry_status);
        return [i + 1, o?.enquiry_type, formatDate(o?.created_at), o?.customer_name, o?.customer_mobile, o?.product_name ? o?.product_name : o?.saving_plan_name,
        <Chip label={o?.enquiry_status}
            sx={{
                backgroundColor: statusStyle.bg,
                color: statusStyle.color,
                fontWeight: 600,
                width:120
            }}
            size="small" />,
        <Box>
            <Tooltip title="Change Status">
                <IconButton color="primary" onClick={() => openEdit(o)}>
                    <EditIcon />
                </IconButton>
            </Tooltip>
        </Box>
        ];
    });
    const openEdit = (row) => {
        setSelectedRow(row);
        setStatus(row.enquiry_status || "NEW");
        setOpen(true);
    };
    const handleSave = async () => {
        setLoading(true);
        try {
            const url = `${webEndPoint}enquiries/${selectedRow.rfId}/status`;
            await makeRequest("patch", url, {
                enquiry_status: status
            });
            setMessage("Enquiry Status Updated");
            setOpen(false);
            fetchPlanData();
            setLoading(false);
        } catch (err) {
            console.error(err);
            setMessage("Something Went Wrong");
        }
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search By Customer Mobile Number" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
            </Box>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Customer Enquiry List</Typography>
            <DataTable columns={columns} rows={rows} loading={false} />
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle>Update Enquiry Status</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <Select value={status} onChange={(e) => setStatus(e.target.value)} fullWidth>
                        <MenuItem value="NEW">NEW</MenuItem>
                        <MenuItem value="IN_PROGRESS">IN_PROGRESS</MenuItem>
                        <MenuItem value="COMPLETED">COMPLETED</MenuItem>
                        <MenuItem value="CANCELLED">CANCELLED</MenuItem>
                    </Select>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">Cancel</Button>
                    <Button onClick={handleSave} variant="contained">Save</Button>
                </DialogActions>
            </Dialog>
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}